import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Card, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import SearchInput from 'components/SearchInput';
import { FilterBar } from 'components';
import clsx from 'clsx';
import { useDebounce } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center'
  },
  spacer: {
    flexGrow: 1
  },
  button: {
    marginLeft: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  margin: {
    marginTop: '0px'
  }
}));

const Toolbar = props => {
  const {
    searchOptions,
    filterOptions,
    buttonsGroup,
    action,
    searchInputSize
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState('');
  const search = useDebounce(searchValue, 500);

  useEffect(() => {
    setSearchValue(searchOptions?.searchValue || '');
  }, [searchOptions?.searchValue]);

  const isFirstRender = React.useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if(searchOptions?.searchPlaceholder) {
      if (search.length > 2 || search === '') {
        searchOptions.searchAction({ [searchOptions.searchKey]: search.trim(), pageNo: 0 });
        dispatch(action);
      }
    }
  }, [search]);

  const onSearchChange = event => {
    let value = event.target.value;
    setSearchValue(value);
  };

  const reset = () => {
    setSearchValue('');
  };

  return (
    <Card className={classes.root}>
      {(searchOptions || buttonsGroup.length > 0) && <div
        className={clsx(
          classes.row,
          searchInputSize === 'small' ? classes.margin : ''
        )}>
        {searchOptions?.searchPlaceholder && (
          <SearchInput
            className={classes.searchInput}
            placeholder={searchOptions?.searchPlaceholder}
            value={searchValue}
            onChange={onSearchChange}
            onClear={reset}
            style={searchInputSize === 'small' ? { padding: '4px' } : {}}
          />
        )}
        <span className={classes.spacer} />
        {buttonsGroup.length > 0 && (
          buttonsGroup.map((button, index) => {
            if (button.customNode) {
              return (
                <div key={button.name || `custom-node-${index}`} className={classes.button}>
                  {button.customNode}
                </div>
              );
            }

            return (
              <Tooltip
                key={button.name || `button-${index}`}
                title={button?.tooltipTitle || ''}
                placement={button?.tooltipPlacement || 'top'}
                arrow>
                <span>
                  <Button
                    {...(button.startIcon && { startIcon: button.startIcon })}
                    className={classes.button}
                    color="primary"
                    variant="contained"
                    disabled={button.disabled}
                    onClick={button.action}>
                    {button.name}
                  </Button>
                </span>
              </Tooltip>
            );
          })
        )}
      </div>}
      {filterOptions && (
        <FilterBar
          filterOptions={filterOptions}
          action={action}
        ></FilterBar>
      )}
    </Card>
  );
};

Toolbar.prototypes = {
    searchOptions: PropTypes,
    filterOptions: PropTypes.object,
    buttonsGroup: PropTypes.array,
    action: PropTypes.func,
    searchInputSize: PropTypes.string
};

export default Toolbar;
